import React$1 from 'react';

const Slider = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "34",
  viewBox: "0 0 34 34"
}, /*#__PURE__*/React$1.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React$1.createElement("path", {
  stroke: "#FF005F",
  strokeWidth: "2",
  d: "M1 1h32v32H1z"
}), /*#__PURE__*/React$1.createElement("path", {
  fill: "#FF005F",
  d: "M15 15h5v5h-5z"
})));

export default Slider;
